import React from 'react';
import FeedBackForm from './FeedBackForm';
import HelloPeter from '../../assets/images/hello-peter.svg';
import { BodySmall, Heading5, Heading6 } from '../common/GlobalElements/Typography';
import { tokens } from '../../public/tokens.js';
import { StandardButton } from '../common/GlobalElements/StandardButton';
export default function VeryGood(props) {
    return (
        <>
            <div className="tab-pane fade show active" id="verygood" role="tabpanel" aria-labelledby="verygood-tab">
                <div className="tab-pane-head">
                    <Heading6>
                        <span>WOW,</span> thanks for such a great rating
                    </Heading6>
                    <BodySmall>
                        We would appreciate a public comment. Your review will put you in our elite #RavingFans club and
                        you will receive a surprise gift.
                    </BodySmall>
                </div>
                <div className="row reviw-content mb-4 justify-content-center align-items-center">
                    <div className="reviw-col">
                        <div className="">
                            <StandardButton
                                as="a"
                                href="https://www.google.com/search?client=firefox-b-d&q=AIE"
                                target="_blank"
                            >
                                <i className="fab fa-google"></i>
                                Google Review
                            </StandardButton>
                        </div>
                    </div>
                    <div className="reviw-col or-text">
                        <div className="color text-uppercase">
                            <b>Or</b>
                        </div>
                    </div>
                    <div className="reviw-col">
                        <div className="">
                            <StandardButton as="a" href="https://www.hellopeter.com/" target="_blank" rel="noreferrer">
                                <img src={HelloPeter} alt="Hello Peter" style={{ width: '14px', marginRight: '6px' }} />
                                Hello Peter
                            </StandardButton>
                        </div>
                    </div>
                </div>

                <FeedBackForm rating_type={props.rating_type} />
            </div>
        </>
    );
}
